import React, { Component } from "react";

class LeaveSession extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			
		}
	}
 
	componentDidMount(){
		
	}
	
	
	render() {
		return (
			<div className="stream_pop_holder">
				<div className="stream_inner_pop">
					<div className="stream_pop_text">Are you sure you want to leave {this.props.sessionName} class?</div>
					<div className="stream_btns_holder">
						<div className="stream_cancel_btn" onClick={() => this.props.updateStateFromChild({leaveSession: false})}>Cancel</div>
						<div className="stream_confirm_btn" onClick={this.props.leaveSession}>Leave</div>
					</div>
				</div>
			</div>		
	)}
}
export default LeaveSession;
